import { RouterOutput } from "@mindlercare/mindlerapi-client";
import { countries } from "@mindlercare/schema";
import CONSTANTS from "core/constants";
import { format } from "date-fns";
import { useUserHasRole } from "hooks/userHooks";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import PatientItem from "./patientItem";

type PatientInfo = RouterOutput["patients"]["getByUserId"];
export const FreeCardInfo = ({ patient }: { patient: PatientInfo }) => {
  const { t } = useTranslation();
  const isAdmin = useUserHasRole("Admin");
  const showFreeCardData =
    patient?.countryId === countries.SE.countryId && isAdmin;

  if (!showFreeCardData) {
    return null;
  }

  return (
    <>
      <PatientItem
        title={t("FREE_CARD")}
        value={patient.freecard.freeCardNumber ?? t("FREE_CARD_NOT_SET")}
      />
      <PatientItem
        valueTextColor={isExpiredFreeCard(patient) ? "RED" : undefined}
        title={t("FREE_CARD_VALID_UNTIL")}
        value={getFreeCardExpiredText(patient, t)}
      />
    </>
  );
};

const isExpiredFreeCard = (patient: PatientInfo) => {
  if (!patient) {
    return false;
  }

  const { freeCardNumber, freeCardExpiryDate } = patient.freecard;

  if (!freeCardNumber?.length) {
    return false;
  }

  if (!freeCardExpiryDate) {
    return false;
  }

  const freeCardExpiresAt = new Date(freeCardExpiryDate);
  const dateToBeCompared = new Date();
  // Free-card is valid on day also
  dateToBeCompared.setHours(0);
  dateToBeCompared.setMinutes(0);
  dateToBeCompared.setSeconds(0);
  dateToBeCompared.setMilliseconds(1);

  return freeCardExpiresAt.getTime() < dateToBeCompared.getTime();
};

const getFreeCardExpiredText = (
  patient: PatientInfo,
  t: TFunction<"translation", undefined>,
) => {
  if (!patient) return;
  const { freeCardExpiryDate } = patient.freecard;
  if (freeCardExpiryDate) {
    return format(
      new Date(freeCardExpiryDate),
      CONSTANTS.DATE_FORMAT.DEFAULT_DATE_FORMAT,
    );
  }

  return t("FREE_CARD_MISSING_VALID_UNTIL");
};
